import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@/helpers/api';
import EmployeesService from '@/services/EmployeesService';
import { types, actions } from './reducer';

function* deleteEmployee({ id }) {
    try {
        yield call(EmployeesService.deleteOne, id);
        yield put(actions.deleteEmployeeSucceeded(id, 'employee deleted successfully'));
    } catch (error) {
        yield put(actions.deleteEmployeeFailed(extractError(error)));
    }
}

function* watchDeleteEmployee() {
    yield takeEvery(
        types.REQUEST_DELETE_EMPLOYEE,
        deleteEmployee,
    );
}

function* employeeDeleteSaga() {
    yield all([
        fork(watchDeleteEmployee),
    ]);
}

export default employeeDeleteSaga;
